import { Box } from "@mui/material";
import React from "react";

import MainHeader from "../../shared/MainHeader";

import CasePageTable from "../../components/CasePageTable/index";

const CasePage = () => {
  return (
    <Box>
      <MainHeader headingText={"Cases"} />

      <CasePageTable />
    </Box>
  );
};

export default CasePage;
